import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import ShopNav from '../../../components/shopNav/ShopNav';
import Footer from '../../../components/footer/Footer';
import NavCategorias from '../../../components/navbar/NavCategorias';
import { useSelector, useDispatch } from 'react-redux';
import { clearPreviousRoute } from '../../../store/navigationSlice';
import ReCAPTCHA from 'react-google-recaptcha';
import './LoginForm.css';

// ✅ Variable de entorno
const API_URL = import.meta.env.VITE_API_URL;




const LoginForm = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [formData, setFormData] = useState({ email: '', password: '' });
  const [errors, setErrors] = useState({});
  const [showPassword, setShowPassword] = useState(false);
  const [serverError, setServerError] = useState('');
  const previousRoute = useSelector(state => state.navigation.previousRoute);

  const [recaptchaToken, setRecaptchaToken] = useState(null);

  const validate = () => {
    const newErrors = {};
    if (!formData.email.trim()) {
      newErrors.email = 'El correo es obligatorio.';
    } else if (!/^\S+@\S+\.\S+$/.test(formData.email)) {
      newErrors.email = 'El correo no es válido.';
    }

    if (!formData.password) {
      newErrors.password = 'La contraseña es obligatoria.';
    } else if (formData.password.length < 6) {
      newErrors.password = 'Debe tener al menos 6 caracteres.';
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setServerError('');

    if (!validate()) return;

    if (!recaptchaToken) {
      setServerError('Por favor completa el reCAPTCHA.');
      return;
    }


    try {
      const res = await axios.post(`${API_URL}/authStore/signin`, {
        ...formData,
        recaptchaToken,
      });
      console.log('✅ Login exitoso', res.data);

      const { token, user } = res.data;

      localStorage.setItem('token', token);
      localStorage.setItem('user', JSON.stringify(user));

      navigate(previousRoute?.pathname || '/mi-cuenta');
      dispatch(clearPreviousRoute());

    } catch (err) {
      console.error('❌ Error al iniciar sesión', err);
      setServerError('Correo o contraseña incorrectos.');
    }
  };


  return (
    <div className="login-page">
      <ShopNav />
      <NavCategorias />

      <main className="login-page-main">
        <section className="login-page-hero login-page-elevated-wrap login-page-elevated-wrap--hero">
          <div className="container login-page-hero-inner">
            <div className="login-page-hero-copy">
              <h1 className="display-5">Bienvenido de nuevo</h1>
              <p className="lead">
                Ingresa a tu cuenta para continuar con tus pedidos, carrito y configuracion.
              </p>
            </div>
            <div className="login-page-hero-logo-wrap" aria-hidden="true">
              <img src="/images/VPA.png" alt="Vintage Pro Audio" className="login-page-hero-logo" />
            </div>
          </div>
        </section>

        <section className="container login-content-wrap">
          <div className="login-form-shell">
            <div className="login-form-head text-center">
              <h3 className="login-form-title">Iniciar Sesion</h3>
              <p className="login-form-subtitle">Accede con tu correo y contrasena para seguir comprando.</p>
            </div>

            <form onSubmit={handleSubmit} noValidate className="login-form-body">
              <div className="mb-3">
                <label htmlFor="email" className="form-label login-form-label">Correo electronico</label>
                <input
                  type="email"
                  name="email"
                  id="email"
                  className={`form-control login-input ${errors.email ? 'is-invalid' : formData.email ? 'is-valid' : ''}`}
                  value={formData.email}
                  onChange={handleChange}
                />
                {errors.email && <div className="invalid-feedback">{errors.email}</div>}
              </div>

              <div className="mb-3">
                <label htmlFor="password" className="form-label login-form-label">Contrasena</label>
                <div className="input-group login-input-group">
                  <input
                    type={showPassword ? 'text' : 'password'}
                    name="password"
                    id="password"
                    className={`form-control login-input ${errors.password ? 'is-invalid' : formData.password ? 'is-valid' : ''}`}
                    value={formData.password}
                    onChange={handleChange}
                  />

                  <button
                    type="button"
                    className="btn login-password-toggle"
                    onClick={() => setShowPassword(!showPassword)}
                    id="togglePassword"
                  >
                    {showPassword ? 'Ocultar' : 'Mostrar'}
                  </button>
                </div>
                {errors.password && <div className="invalid-feedback d-block">{errors.password}</div>}
              </div>

              <div className="mb-3 text-end">
                <a href="/recuperar-password" className="login-forgot-link text-decoration-none">Olvidaste tu contrasena?</a>
              </div>

              <div className="login-recaptcha-wrap mb-3 d-flex justify-content-center">
                <ReCAPTCHA
                  sitekey="6LcHco8rAAAAALYNxuX2ypmiOPyohdfU2CHJurL6"
                  onChange={(token) => setRecaptchaToken(token)}
                  className="mb-3"
                />
              </div>

              {serverError && (
                <div className="alert alert-danger text-center login-server-error" role="alert">
                  {serverError}
                </div>
              )}

              <button type="submit" className="btn w-100 mb-3 login-submit-btn">Ingresar</button>
            </form>

            <div className="text-center my-3 login-divider-wrap">
              <span className="login-divider-text">O continua con</span>
              <hr className="mt-1 mb-3" />
            </div>
          </div>
        </section>
      </main>

      <Footer />
    </div>
  );
};

export default LoginForm;
